import React from 'react';
import RiskTolerance from '../../../../../../Profile/RiskTolerance/RiskTolerance';

interface Props {
  clientId: string;
}

export const RiskToleranceResults = ({ clientId }: Props) => {
  return (
    <>
      <RiskTolerance showPortfolioSelection={false} clientId={clientId} key={`rt_${clientId}`} />
    </>
  );
};
